module.exports = __webpack_public_path__ + "img/services-03-portrait.c45cdea5.jpg";